import xhr from '../../Xhr'

const API = (username, mail) => ({
  auth: {
    login: {
      url: process.env.REACT_APP_API_SERVER + '/v1/vdn/login',
      method: 'POST'
    },
    forgetPwd: {
      url: process.env.REACT_APP_API_SERVER + `/v1/vdn/app/forget_password`,
      method: 'POST'
    },
    sendCode: {
      url: process.env.REACT_APP_API_SERVER + `/v1/vdn/username/vcode?username=${username}`,
      method: 'GET'
    }
  }
})

const sendAPI = (phone, code) => ({
  auth: {
    sendCode: {
      url: process.env.REACT_APP_API_SERVER + `/v1/vdn/vcode?mobile=${phone}&country_code=${code}&name=ShadowFog`,
      method: 'GET'
    }
  }
})

const signupAPI = (name) => ({
  auth: {
    signup: {
      url: name.length > 0 ? process.env.REACT_APP_API_SERVER + `/v1/vdn/signup?agent=${name}` : process.env.REACT_APP_API_SERVER + `/v1/vdn/signup`,
      method: 'POST'
    }
  }
})

export const login = ({data, ...event}) => {
  return xhr({
    api: API().auth.login,
    action: 'AUTH/LOGIN',
    data,
    event
  })
}

export const sendCode = ({phone, code, ...event}) => {
  return xhr({
    api: sendAPI(phone, code).auth.sendCode,
    action: 'SEND/CODE',
    event
  })
}

export const signup = ({data, name, ...event}) => {
  return xhr({
    api: signupAPI(name).auth.signup,
    action: 'AUTH/SIGNUP',
    data,
    event
  })
}

export const forgetPwdSubmit = ({data, ...event}) => {
  return xhr({
    api: API().auth.forgetPwd,
    action: 'FORGET/SUBMIT',
    data,
    event
  })
}

export const forgetPwdSend = ({data, ...event}) => {
  return xhr({
    api: API(data.username).auth.sendCode,
    action: 'FORGET/SEND',
    event
  })
}

export const logout = () => ({
  type: 'AUTH/LOGOUT'
})


// WEBPACK FOOTER //
// ./src/modules/auth/actions.js